/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Status_Export_Failed_With_ErrorInputs */

const en_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot export video: ${i?.error}`)
};

const fr_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible d'exporter la video : ${i?.error}`)
};

const de_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Videoexport fehlgeschlagen: ${i?.error}`)
};

const it_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile esportare il video: ${i?.error}`)
};

const ru_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Невозможно экспортировать видео: ${i?.error}`)
};

const es_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede exportar el vídeo: ${i?.error}`)
};

const zh_cn2_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法导出视频：${i?.error}`)
};

const ja_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオをエクスポートできません: ${i?.error}`)
};

const hi_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात नहीं किया जा सकता: ${i?.error}`)
};

const pt_pt2_video_export_status_export_failed_with_error = /** @type {(inputs: Video_Export_Status_Export_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível exportar o vídeo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Cannot export video: {error}" |
*
* @param {Video_Export_Status_Export_Failed_With_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_export_failed_with_error = /** @type {((inputs: Video_Export_Status_Export_Failed_With_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_Export_Failed_With_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_status_export_failed_with_error(inputs)
	if (locale === "de") return de_video_export_status_export_failed_with_error(inputs)
	if (locale === "it") return it_video_export_status_export_failed_with_error(inputs)
	if (locale === "ru") return ru_video_export_status_export_failed_with_error(inputs)
	if (locale === "es") return es_video_export_status_export_failed_with_error(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_status_export_failed_with_error(inputs)
	if (locale === "ja") return ja_video_export_status_export_failed_with_error(inputs)
	if (locale === "hi") return hi_video_export_status_export_failed_with_error(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_status_export_failed_with_error(inputs)
	return en_video_export_status_export_failed_with_error(inputs)
});